<template>
  <div id="I-APC-RM">
    <vs-row vs-w="12">
      <vs-row vs-w="12" vs-type="flex">
        <vs-col
          vs-w="12"
          vs-lg="2"
          vs-sm="12"
          vs-xs="12"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <CardSensor />
        </vs-col>
        <vs-col
          vs-w="12"
          vs-lg="3"
          vs-sm="12"
          vs-xs="12"
          vs-justify="center"
          vs-align="center"
        >
          <vs-row vs-w="12" vs-lg="12" vs-sm="6" vs-xs="12" vs-type="flex">
            <CardTotalWorker />
          </vs-row>
          <vs-row vs-w="12" vs-lg="12" vs-sm="6" vs-xs="12" vs-type="flex">
            <CardActiveWorker />
          </vs-row>
        </vs-col>
        <vs-col vs-w="12" vs-lg="7" vs-sm="12" vs-xs="12" vs-type="flex">
          <vs-row vs-w="12" vs-type="flex">
            <vs-col vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex">
              <CardChartTatalWork />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" vs-type="flex">
        <vs-col>
          <CardListEmployee
            :department="$store.getters['i_APC/department']"
          />
        </vs-col>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
import { clearTimeout } from 'highcharts';
import CardActiveWorker from "./components/RM/CardActiveWorker.vue";
import CardChartTatalWork from "./components/RM/CardChartTatalWork.vue";
import CardListEmployee from "./components/RM/CardListEmployee.vue";
import CardSensor from "./components/RM/CardSensor.vue";
import CardTotalWorker from "./components/RM/CardTotalWorker.vue";

export default {
  components: {
    CardSensor,
    CardTotalWorker,
    CardActiveWorker,
    CardChartTatalWork,
    CardListEmployee,
  },
  data() {
    return {
      listTag: [],
      listTag2: [],
      time: null,
      numWorker: 0,
      numActive: 0,
    };
  },
  async mounted() {
    this.calldata()
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
  methods: {
    async calldata(){
      await this.$store.dispatch("i_APC/getTagInfo");
      this.time = setTimeout(async () => {
        await this.calldata()
    }, 20 * 1000);
    },
    // not use
    async getTagInfo() {
      this.listTag = [];
      this.listTag2 = [];
      this.numWorker = 0;
      this.numActive = 0;
      let res = await this.$API.get("iAPC/getinfo/current");
      if (res.status == 200) {
        console.log(res.data);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          if (el.name != null && el.name != "") {
            if ((this.listTag.length + this.listTag2.length) % 2 == 0) {
              this.listTag.push(el);
            } else {
              this.listTag2.push(el);
            }

            if (el.status != null) {
              this.numWorker++;
            } else if (el.status == "in") {
              this.numActive++;
            }
          }
        }
      }
      console.log(this.listTag);
    },
    // not use
    async updateTagInfo() {
      let res = await this.$API.get("iAPC/getinfo/current");
      let numWorker = 0,
        numActive = 0;
      if (res.status == 200) {
        console.log(res.data[0]);
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          for (let j = 0; j < this.listTag.length; j++) {
            const ellistTag = this.listTag[j];

            if (el.tag == ellistTag.tag) {
              this.listTag[j] = el;
            }
          }
          for (let j = 0; j < this.listTag2.length; j++) {
            const element = this.listTag2[j];

            if (el.tag == this.listTag2[j].tag) {
              this.listTag2[j] = el;
            }
          }

          if (el.status != null) {
            numWorker++;
          } else if (el.status == "in") {
            numActive++;
          }
        }
        this.numWorker = numWorker;
        this.numActive = numActive;
      }
    },
  },
};
</script>

<style>
</style>